import { Component, HostBinding, computed, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <img src="tco-logo.svg" alt="TCO logo" [class]="imgClass()" /> `,
})
export class LogoComponent {
  readonly size = input<number | null>(null);

  @HostBinding('style.display') protected readonly hostDisplay = 'inline-flex';
  @HostBinding('style.width.px') protected get hostWidth(): number | null {
    return this.size();
  }
  @HostBinding('style.height.px') protected get hostHeight(): number | null {
    return this.size();
  }

  protected readonly imgClass = computed(() =>
    this.size() ? 'block h-full w-full shrink-0' : 'block h-10 w-auto shrink-0',
  );
}
